import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { attribute } from "./ShowModal";


// Models
interface product_attribute {
    name: string;
    value: string;
}

export interface showService {
    name: string;
    description: string;
    serial_number: string;
    attributes: attribute[];
    product_attributes?: product_attribute[];
}

// Show service state
export interface showServiceState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: showService;
}

const initialShowServiceState: showServiceState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {
        name: "",
        description: "",
        serial_number: "",
        attributes: []
    }
}

// Show service slice
export const showServiceSlice = createSlice({
    name: 'show_service',
    initialState: initialShowServiceState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<showService> ) => {
            state.data = { ...state.data, ...payload }
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean, product_attributes?: product_attribute[] }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
            if(payload.product_attributes)
                state.data.product_attributes = payload.product_attributes
        }
    }
})